export default __webpack_public_path__ + "static/media/intro_img4.813118fb.png";